import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpCacheService } from '../services/http-cache-service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

    private cacheConfig: { [path: string]: number } = {
        '/v1/code-master': 5 * 60 * 1000,
        '/v1/companies': 15 * 1000,
        '/v1/members': 15 *  1000
    };

    constructor(private httpCacheService: HttpCacheService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.method === 'GET') {
            const matchedPath = Object.keys(this.cacheConfig).find(path => req.urlWithParams.includes(path));

            if (matchedPath) {
                const cachedResponse = this.httpCacheService.getCachedData(req.urlWithParams);

                if (cachedResponse) {
                    return of(new HttpResponse({ body: cachedResponse }));
                } else {
                    return next.handle(req).pipe(
                        tap(event => {
                            if (event instanceof HttpResponse && event.status === 200) {
                                const cacheTime = this.cacheConfig[matchedPath];
                                this.httpCacheService.setCachedData(req.urlWithParams, event.body, cacheTime);
                            }
                        })
                    );
                }
            }
        }

        return next.handle(req);
    }

}
